import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { PATHS } from '@/common';
import { GET_TRANSACTION_DETAILS_BY_CLAIM_ID } from '@/modules/transaction/hooks/useGetTransactionDetails.query';

interface Payload {
  claim_ids?: number[];
  payment_method_id?: number;
  transact_method?: string;
}

interface Props {
  claimId?: string;
  onSuccess?: () => void;
  onError?: (errorText: string) => void;
}

const useRetryPaymentQuery = ({ claimId, onSuccess, onError }: Props) => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading, isError, isSuccess } = useMutation(
    (params: Payload) => api.post(PATHS.RETRY_PAYMENT, params),
    {
      onSuccess: () => {
        if (onSuccess) onSuccess();
        queryClient.invalidateQueries({
          queryKey: [GET_TRANSACTION_DETAILS_BY_CLAIM_ID, claimId],
        });
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onError: (data?: any) => {
        if (onError && data?.response?.data?.elevate_error_message) {
          onError(data.response.data.elevate_error_message);
        }
      },
    }
  );

  return {
    retryPayment: mutateAsync,
    isLoading,
    isSuccess,
    isError,
  };
};

export default useRetryPaymentQuery;
